import Menu from "../../components/menu/menu";
import Busca from "../../components/busca/busca";
import Indicador from "../../components/indicador/indicador";
import Grafico from "../../components/grafico/grafico";
import { useEffect, useState } from "react";
import api from "../../services/api";


function Dashboard(){

    // let DadosIndicadores = {
    //     leads: 135,
    //     visitas: 15,
    //     clientes: 10,
    //     clientes_abertos: 5
    // }
    const abancos = [
        ["Banco ", "Valor"],
        ["01", 1000],
        ["02", 1170],
        ["03", 660],
        ["04", 1030],
      ];
    const [DadosIndicadores, setDadosIndicadores] = useState({});
    const [DadosMensais    , setDadosMensais]     = useState([]);

    function MontarIndicadores(){
//        api.get("/crm/indicadores?CNPJ="+localStorage.getItem("CNPJ")+"&usuario="+localStorage.getItem("USUARIO")+"&dia="+Date)
        api.get("/crm/indicadores?CNPJ=05695894000103&usuario=MAX&dia="+encodeURI("23/01/2024"))  
        .then((resp) => {  //aguarda a resposta do comando get anterior
          setDadosIndicadores(resp.data);
        })
        .catch((err) => {
            setDadosIndicadores({});
        });
    }

    function MontarGrafico(){
        setDadosMensais([
            ["Mês", "Valor"],
            ["01", 10],
            ["02", 11],
            ["03", 16],
            ["04", 6],
            ["05", 25],
            ["06", 33],
            ["07", 19],
            ["08", 25],
            ["09", 17],            
            ["10", 25],            
            ["11", 41],            
            ["12", 30]            
        ])

    }
    function MontarDashboard(){
        MontarIndicadores();
        MontarGrafico();

    }

    //roda quando a tela e carregada
    useEffect(()=>{
        localStorage.setItem("cnpj","05695894000103");
        localStorage.setItem("usuario","");

        MontarDashboard();

    },[]);

    // function Teste (){
    //     // alert('OK');
    //     setDadosIndicadores({
    //         leads: 203,
    //         visitas: 23,
    //         clientes: 19,
    //         clientes_abertos: 8
    //     })
    // }
    return <>
      <div className="container-fluid">
        <div className="row flex-nowrap">
            <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
                <Menu page="dashboard"/>
            </div>

            <div className="col py-3 me-3">
                <div className="mb-5">
                    <Busca texto='Busca por nome...'/>
                </div>

                <div className="d-flex justify-content-between">
                    <h1>Dashboard</h1>
                    <button onClick={MontarDashboard} className="btn btn-primary">Atualizar</button>
                </div>

                <div className="row">
                    <div className="col-md-3 mt-4">
                        <Indicador titulo="Leads cadastrados "
                                   valor={DadosIndicadores.leads}
                                   rodape={`${DadosIndicadores.visitas} visitas`} />

                    </div>
                    <div className="col-md-3 mt-4">
                        <Indicador titulo="Clientes"
                                   valor={DadosIndicadores.clientes}
                                   rodape={`${DadosIndicadores.clientes_abertos} em aberto `} />

                    </div>

                    <div className="col-md-12 mt-5">
                        <Grafico titulo="Leads/mês"
                                 chartType="Line"
                                 dados={DadosMensais}
                                  />

                    </div>
                </div>
                

            </div>

        </div>

      </div>
    </>


}


export default Dashboard;  // deixa visivel para quem quiser utilizar a funcao
